import CommonBasePresenter from '@joyrideautos/ui-models/src/BasePresenter';
import {types} from 'mobx-state-tree';
import CommonRoutingViewModel from '../router/CommonRoutingViewModel';
import RootStoreAwareViewModel from './RootStoreAwareViewModel';

const BasePresenter = types
    .compose(RootStoreAwareViewModel, CommonRoutingViewModel, CommonBasePresenter)
    .named('BasePresenter')
    .actions((self) => ({
        afterCreate() {
            self.presentationStore.containerClassName.setValue(self.containerClassName ?? 'container');
            self.presentationStore.footerVisible.setValue(self.isFooterVisible);
        },
    }));

export default BasePresenter;
